import Vue from 'vue'
import Affix from 'vue-affix'
import vueAwesomeCountdown from 'vue-awesome-countdown'
Vue.use(Affix)

Vue.use(vueAwesomeCountdown, 'vac') // Component name, `countdown` and `vac` by default
